<template>
  <div class="root">
    <a
      :href="`/download-file/${url}`"
      download
      :class="className"
      class="main-btn_download"
    >
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="16" stroke="white" stroke-linecap="round" stroke-dasharray="0.2 4"/>
        <path
          d="M23.6464 26.3536C23.8417 26.5488 24.1583 26.5488 24.3536 26.3536L27.5355 23.1716C27.7308 22.9763 27.7308 22.6597 27.5355 22.4645C27.3403 22.2692 27.0237 22.2692 26.8284 22.4645L24 25.2929L21.1716 22.4645C20.9763 22.2692 20.6597 22.2692 20.4645 22.4645C20.2692 22.6597 20.2692 22.9763 20.4645 23.1716L23.6464 26.3536ZM24.5 18L24.5 17.5L23.5 17.5L23.5 18L24.5 18ZM24.5 26L24.5 18L23.5 18L23.5 26L24.5 26Z"
          fill="white"/>
        <path d="M31 27V29C31 29.5523 30.5523 30 30 30H18C17.4477 30 17 29.5523 17 29V27" stroke="white"
              stroke-linecap="square"/>
      </svg>
      {{ textButton }}
    </a>

    <div v-if="icons" class="download-icon">
      <icon-download
        v-for="item in icons"
        :key="item.icon + new Date().getTime()"
        :url="item.url"
        :icon="item.icon"
        class="download-icon__item"
      ></icon-download>
    </div>

<!--    <a-->
<!--      :href="`../download-file/${url}`"-->
<!--      :class="className"-->
<!--      class="main-btn_download"-->
<!--      @click.prevent="downloadItemZip(`../download-file/${url}`)"-->
<!--    >-->
<!--      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--        <circle cx="24" cy="24" r="16" stroke="white" stroke-linecap="round" stroke-dasharray="0.1 4"/>-->
<!--        <path-->
<!--          d="M23.6464 26.3536C23.8417 26.5488 24.1583 26.5488 24.3536 26.3536L27.5355 23.1716C27.7308 22.9763 27.7308 22.6597 27.5355 22.4645C27.3403 22.2692 27.0237 22.2692 26.8284 22.4645L24 25.2929L21.1716 22.4645C20.9763 22.2692 20.6597 22.2692 20.4645 22.4645C20.2692 22.6597 20.2692 22.9763 20.4645 23.1716L23.6464 26.3536ZM24.5 18L24.5 17.5L23.5 17.5L23.5 18L24.5 18ZM24.5 26L24.5 18L23.5 18L23.5 26L24.5 26Z"-->
<!--          fill="white"/>-->
<!--        <path d="M31 27V29C31 29.5523 30.5523 30 30 30H18C17.4477 30 17 29.5523 17 29V27" stroke="white"-->
<!--              stroke-linecap="square"/>-->
<!--      </svg>-->
<!--      {{ textButton }}-->
<!--    </a>-->
  </div>
</template>

<script>
// import Axios from "axios";

import IconDownload from "../ButtonDownload/IconDownload"
export default {
  name: 'ButtonDownload',
  components: {IconDownload},
  props: {
    url: {
      type: String,
    },
    textButton: {
      type: String,
      default: 'Скачать'
    },
    className: {
      type: String,
    },
    icons: {
      type: Array
    }
  },

  // methods: {
  //   downloadItemZip(url) {
  //     Axios.get(url, {responseType: 'blob'})
  //         .then(response => {
  //           const blob = new Blob([response.data], {type: 'application/zip'})
  //           const link = document.createElement('a')
  //           link.href = URL.createObjectURL(blob)
  //           link.download = 'icons'
  //           link.click()
  //           URL.revokeObjectURL(link.href)
  //         }).catch(console.error)
  //   },
  // }
}
</script>

<style scoped lang="scss">
.root {
  display: flex;
  align-items: center;
}

.main-btn_download {
  background: #0759EA;
  box-shadow: 0px -5px 24px #FDFFFF, 0px 8px 32px rgba(187, 195, 206, 0.9);
  border-radius: 4px;
  padding: 8px 40px 8px 8px;
  font-size: 16px;
  line-height: 18px;
  display: flex;
  color: #fff;
  text-decoration: none;
  align-items: center;
  //text-transform: uppercase;
  letter-spacing: 0.03em;
  font-weight: 400;
  font-family: 'suisse_intl', serif;

  &:hover {
    background: #0652D8;
    box-shadow: 0 20px 40px -8px rgba(5, 71, 186, 0.4);
  }

  &:active {
    background: #064ECC;
    box-shadow: 0px -2px 8px rgba(253, 255, 255, 0.9), 0px 4px 24px rgba(187, 195, 206, 0.8);
  }

  svg {
    margin-right: 12px;
  }
}

.download-icon {
  display: flex;
  margin-left: 32px;
  &__item {
    margin-right: 12px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>